// Returns action creators for each cart action type
import {
    SET_PUNCH_OUT_CART_ACTIVE,
    SET_PUNCH_OUT_SESSION_ID,
    SET_PUNCH_OUT_SESSION_IN_PROGRESS,
    SET_PUNCH_OUT_SUPPLIERS,
    SET_PUNCH_OUT_TAB,
} from "../actionTypes";

export const loadPunchOutSuppliers = (punchOutSuppliers) => {
    return {
        type: SET_PUNCH_OUT_SUPPLIERS,
        payload: punchOutSuppliers,
    };
};

export const setPunchOutCartActive = (isActive) => {
    return {
        type: SET_PUNCH_OUT_CART_ACTIVE,
        payload: isActive,
    };
};

export const setPunchOutSessionInProgress = (isInProgress) => {
    return {
        type: SET_PUNCH_OUT_SESSION_IN_PROGRESS,
        payload: isInProgress,
    };
};

export const setPunchOutSessionId = (sessionId) => {
    return {
        type: SET_PUNCH_OUT_SESSION_ID,
        payload: sessionId,
    };
};

export const setPunchOutTab = (tab) => {
    return {
        type: SET_PUNCH_OUT_TAB,
        payload: tab,
    };
};
